import { Button } from '@salutejs/sdds-insol';
import { Typography } from '@/shared/ui/Typography';
import cls from './GoalItem.module.scss';

type Props = {
    image: string;
    title: string;
    onClick: () => void;
};

export const GoalItem = ({ title, image, onClick }: Props) => {
    return (
        <div className={cls.container}>
            <Typography className={cls.title} as="p" variant="text_18_bold">
                {title}
            </Typography>
            <img className={cls.image} alt="img" src={image} />
            <Button className={cls.button} size="xs" view="white" stretch onClick={onClick}>
                Выбрать
            </Button>
        </div>
    );
};
